module.exports = __webpack_public_path__ + "static/start-call-bg-d4fba4dff43000325674e4ddabcaf36e.svg";